import React from 'react';
import SearchBar from 'Common/Components/SearchBar/index';
import 'Common/styles/commonStyles.scss';
import { useSelector } from 'react-redux';
import { selectPathname } from 'store/Router/selectors';

const Searcher = () => {
  const pathname = useSelector(selectPathname);

  const canShowNewSearcher =
    (pathname.includes('/manage')) ||
    pathname.includes('/host') ||
    (pathname.includes('/knowledge_base')) ||
    pathname.includes('/vulnerabilities') ||
    pathname.includes('/workspaces') ||
    pathname.includes('/services') ||
    pathname.includes('/service') ||
    pathname.includes('/report') ||
    pathname.includes('/automation/schedule') ||
    pathname.includes('/credentials');

  if (canShowNewSearcher) return <SearchBar />;

  return null;
};

export default Searcher;
